var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.611 14.385C5.572 13.346 5 11.965 5 10.496C5 9.027 5.572 7.645 6.611 6.607C7.683 5.534 9.092 4.998 10.5 4.998C11.908 4.998 13.317 5.534 14.389 6.607C15.428 7.645 16 9.027 16 10.496C16 11.965 15.428 13.346 14.389 14.385C12.245 16.53 8.756 16.529 6.611 14.385ZM20.425 19.005L16.459 15.038C17.454 13.738 18 12.161 18 10.496C18 8.492 17.22 6.609 15.803 5.193C12.88 2.269 8.122 2.269 5.197 5.193C3.78 6.609 3 8.492 3 10.496C3 12.499 3.78 14.383 5.197 15.799C6.659 17.261 8.58 17.992 10.5 17.992C12.106 17.992 13.708 17.474 15.045 16.452L19.011 20.419C19.207 20.614 19.463 20.712 19.718 20.712C19.974 20.712 20.23 20.614 20.425 20.419C20.816 20.028 20.816 19.395 20.425 19.005Z",
    fill: "#2B2B2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.b27160f2bcad932d5cd00aa39678b500.svg";
export { ForwardRef as ReactComponent };